export default __webpack_public_path__ + "static/media/Poverty-Alleviation.2fe85473.png";